// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  defaultLocale: 'es',
  production: false,

 // webApiBaseDesdeFuera: 'http://localhost:5243/wsCM.svc/',
  // webApiBaseDesdeDentro: 'http://localhost:5243/wsCM.svc/'

  // SERVIDOR DE PRUEBAS
    // webApiBaseDesdePortal: 'https://wsAConsumer.tresbits.es/wsAConsumer.svc/'
  // SERVIDOR BUENO
     webApiBaseDesdePortal:  'https://appainiaconsumer.consumolab.es/wsAConsumer/wsAConsumer.svc/'

};



// WEBPACK FOOTER //
// ./src/environments/environment.ts